import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

export const focusable = (theme: Theme) => css`
  &:focus-visible {
    outline: 2px solid ${theme.palette.primary.maxContrast};
    outline-offset: 2px;
  }
`
